import React,  { Component } from 'react'
import { connect } from 'react-redux'
import InputText from '../components/formulario/InputText'
import {    LOGIN as loginActions,
    USUARIO as guardarUsuarioActions,
    PASO_ACTUAL_F1 as actualizaPasoActualActions,
    LOGOUT as logoutAction} from '../../service/actions'

class ChangePassword extends Component {

    state = {
        
        password : '',
        v_password : '',
        m_password : '',
        verifpassword: '',
        v_verifpassword : '',
        m_verifpassword : '',
        v_login : false
    }

    onChange = (e) => {
        let { value , name } = e.target;
        this.setState({[name] : value}, () => {this.validarPassword()})
    }

    validarPassword = () => {

        let empty_password = this.state.password === ''
        let empty_verifpassword = this.state.verifpassword === ''

        this.setState({v_password : !empty_password, 
                       v_verifpassword : !empty_verifpassword,
                       v_login : !(empty_password || empty_verifpassword),
                       m_verifpassword : ((empty_password || empty_verifpassword) ? 'Debe escribir una contraseña' : '')})

        if(this.state.password && this.state.verifpassword && this.state.password !== '' && this.state.verifpassword !== ''){
            if(this.state.password !== this.state.verifpassword){
                this.setState({v_verifpassword : false, v_login : false, m_verifpassword : 'Las contraseñas no coinciden'})
            }else{
                this.setState({v_verifpassword : true, v_login : true, m_verifpassword : 'Las contraseñas coinciden!'})
            }
        }
    }

    render(){
        return(
            <div className="login">
                <p className='welcome-ss'>Hola!</p>
                <p className='welcome-ss-tranqui'>Es necesario que cambies tu contraseña</p>

                <p className={'guia-parrafo '+ (this.props.hintPassword ? 'guia-rojo' : '')}>La nueva contraseña debe tener un tamaño mínimo de 8 caracteres. Además debe contener letras mayúsculas, minúsculas, números y caracteres especiales.</p>
                
                <InputText 
                    name = "password"
                    value = {this.state.password}
                    placeholder="Contraseña"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_password}
                    minLength="8"
                    maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "password" />
                
                <InputText 
                    name = "verifpassword"
                    value = {this.state.verifpassword}
                    placeholder="Confirmar Contraseña"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_verifpassword}
                    minLength="8"
                    maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "password" />
                
                {this.state.m_verifpassword === '' ? null : <span className={ (this.state.v_password && this.state.v_verifpassword) ? "message-success" : "message-error"}>* {this.state.m_verifpassword}</span> }  
                
                <div className="input-button">
                    <button onClick={()=>this.props.onClick(this.state)} className={this.state.v_login === true?"btn-login btn w100 no-box-shadow":"btn-login-inactive btn w100 no-box-shadow"}>
                        CONTINUAR
                    </button>
                </div>

            </div>
        )
    }

}

const mapStateToProps = store => {
    return {
        usuario : store.usuario
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actualizarLogin : (isLogin) => dispatch(loginActions(isLogin)),
        guardarUsuario: (custom) => dispatch(guardarUsuarioActions(custom)),
        actualizaPasoActual : (paso) => dispatch(actualizaPasoActualActions(paso)), 
        logout : () => dispatch(logoutAction())    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)